import { render, staticRenderFns } from "./messageTemplateView.vue?vue&type=template&id=00db1af1"
import script from "./messageTemplateView.vue?vue&type=script&lang=js"
export * from "./messageTemplateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports